
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileScreenComponent } from './mobile-screen.component';
import { ButtonModule, SystemIconModule } from '@serviceos-ng/core';


@NgModule({
  declarations: [
    MobileScreenComponent
  ],
  imports: [
    CommonModule,
    SystemIconModule,
    ButtonModule
  ], 
  exports: [
    MobileScreenComponent
  ]
})
export class MobileScreenModule { }
